<template>
  <v-data-table
    item-key="id"
    :options.sync="busTableOptions"
    :items-per-page="10"
    :server-items-length="totalItems"
    :headers="headers"
    :footer-props="footerTable"
    :items="busesData"
    sort-by="name"
    @input="$emit('update:selected', $event)"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    no-data-text="Không có xe"
  >
    <template v-slot:[`item.name`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" style="text-decoration: none; white-space: nowrap">
            <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/bus/' + item.id">{{
              item.name
            }}</router-link>
          </div>
        </template>
        <span>Xem tuyến xe</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.maxStudent`]="{ item }">
      {{ item.data && item.data.maxStudent }}
    </template>
    <template v-slot:[`item.driver`]="{ item }">
      {{ item.driver ? item.driver.name : '' }}
    </template>
    <template v-slot:[`item.phone`]="{ item }">
      {{ item.phone }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip
        small
        style="margin: 0"
        class="white--text"
        v-if="item.status"
        :color="item.status | busStatusColor"
        label
      >
        {{ item.status | busStatus }}
      </v-chip>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'

const originHeaders = [
  {
    text: 'Tên tuyến',
    value: 'name',
    align: 'left',
    sortable: false
  },
  {
    text: 'Số học sinh tối đa',
    value: 'maxStudent',
    align: 'left',
    sortable: false
  },
  {
    text: 'Tên lái xe',
    value: 'driver',
    align: 'left',
    sortable: false
  },
  {
    text: 'Số điện thoại',
    value: 'phone',
    align: 'center',
    sortable: false
  },
  {
    text: 'Tình trạng',
    value: 'status',
    align: 'left',
    sortable: false
  }
]

export default {
  props: {},
  data() {
    return {
      selected: [],
      search: '',
      headers: originHeaders,
      editingItem: null,
      status: null,
      busTableOptions: {}
    }
  },
  methods: {
    ...mapActions('bus', ['requestPageSettings', 'searchBuses']),
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    async refresh(query) {
      query = query || {}
      this.searchBuses({
        ...query
      })
    }
  },
  computed: {
    ...mapState('bus', ['busesData', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Tuyến xe mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  watch: {
    busTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
